import Keycloak from 'keycloak-js';
import {getDomain} from "./domain";

let keycloakInstance = null;

export const keycloakRealm = 'transcription-test';
export const keycloakClientId = `${keycloakRealm}-frontend`;
export const initKeycloak = () => {
  if (keycloakInstance) {
    return Promise.resolve(keycloakInstance.authenticated);
  }

  const domain = getDomain();
  keycloakInstance = new Keycloak({
    url: `https://auth.${domain}`,
    realm: keycloakRealm,
    clientId: keycloakClientId,
  });

  return keycloakInstance.init({
    onLoad: 'login-required',
    checkLoginIframe: false, // required in development mode to avoid refresh loop
  });
};

export const logout = () => {
  if (keycloakInstance) {
    return keycloakInstance.logout();
  }
};

export const getToken = () => {
  if (keycloakInstance) {
    return keycloakInstance.token;
  }
};

export const isAuthenticated = () => {
  return keycloakInstance ? keycloakInstance.authenticated : false;
};
